import React from "react";
import { Routes, Route } from "react-router-dom";

import LanguageProvider from "./context/LanguageProvided";
import "./App.css";

//components
import FlxMain from "./components/branch/flxdeck/FlxdeckMain.js";
import Home from "./components/homepage/Home.js";
import EconoMain from "./components/branch/econo/EconoMain.js";
import PrivacyPolicy from "./components/homepage/PrivacyPolicy.js";
import PolitiqueConfidencialite from "./components/homepage/PolitiqueConfidentialite.js";
import EconoWorkout from "./components/branch/econo/EconoWorkout.js";
import BigDaddyFitnessMain from "./components/branch/bigdaddyfitness/BigDaddyFitnessMain.js";
import BigDaddyFitnessWorkout from "./components/branch/bigdaddyfitness/BigDaddyFitnessWorkout.js";
import BigDaddyFitnessWorkoutDetails from "./components/branch/bigdaddyfitness/BigDaddyFitnessWorkoutDetails.js";
import FlxdeckWorkout from "./components/branch/flxdeck/FlxdeckWorkout.js";
import FlxdeckWorkoutDetails from "./components/branch/flxdeck/FlxDeckWorkoutDetails.js";
import MobileDisplay from "./components/TEST/mobileDisplay.js";
import TermsConditions from "./components/homepage/TermsConditions.js";
import ConditionsGenerales from "./components/homepage/ConditionsGenerales.js";

function App() {
  return (
    <LanguageProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/politique-confidencialite" element={<PolitiqueConfidencialite />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/conditions-generales" element={<ConditionsGenerales />} />
        <Route path="/demo" element={<FlxMain />} />
        <Route path="/econo" element={<EconoMain />} />
        <Route path="/bigdaddyfitness" element={<BigDaddyFitnessMain />} />
        <Route path="/bigdaddyfitnessworkout" element={<BigDaddyFitnessWorkout />} />
        <Route path="/bigdaddyfitnessworkoutdetails" element={<BigDaddyFitnessWorkoutDetails />} />
        <Route path="/workout" element={<FlxdeckWorkout />} />
        <Route path="/workoutdetails" element={<FlxdeckWorkoutDetails />} />
        <Route path="/econoworkout" element={<EconoWorkout />} />
        <Route path="/mobile" element={<MobileDisplay />} />
      </Routes>
    </LanguageProvider>
  );
}

export default App;
